exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speed-btn[data-v-02e7ddda]{display:inline-block;line-height:21px;height:22px;border:1px solid #0095ff;color:#0095ff;font-size:12px;padding:0 10px;border-radius:20px}", ""]);

// exports
